module.exports = __webpack_public_path__ + "img/dog.5ee0a344.png";